<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-invoice" icon-small title="صورتحساب مشتریان" color="accent">

			<div cols="12" class="pa-5 pt-0">
				<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
					<v-tab :key="0">صورتحساب جدید</v-tab>
					<v-tab :key="1">گزارش صورتحساب ها</v-tab>

					<v-tabs-items v-model="activeTab" touchless class="mt-3">
						<v-tab-item :key="0">
							<v-slide-x-transition :hide-on-leave="true">
								<div v-if="step === 1">
									<v-row class="justify-center">
										<v-col cols="12" md="6">
											<v-form @submit.prevent="searchCustomer">
												<div class="mb-2 mt-4">
													ابتدا مشتری مورد نظر را جستجو کنید:
													<div><small class="grey--text">(جستجو میتواند بر اساس نام و نام خانوادگی، کدملی، شماره کارت، شماره موبایل باشد)</small></div>
												</div>
												<v-text-field class="mb-4" ref="nationalCode" outlined v-model="searchPhrase" maxlength="50" label="اطلاعات مورد نظر را وارد کنید:" :error-messages="errorMessages" :rules="[() => !!searchPhrase || 'اطلاعات را وارد کنید']" required />
												<v-alert class="mb-2 mt-2" type="error" outlined v-if="searchMessage">{{ searchMessage }}</v-alert>
												<v-btn color="primary" type="submit" :loading="searchLoading" block>
													جستجوی مشتری
												</v-btn>
											</v-form>
										</v-col>
									</v-row>
									<div v-if="members !== null" style="padding: 10px;border: 1px solid #ddd;border-radius: 10px;margin-top: 25px;">
										<div class="mb-2 pa-2 pr-0 secondary--text" style="border-bottom: 1px dashed #ddd;">لیست مشتریان یافت شده مطابق با اطلاعات وارد شده:</div>
										<v-alert v-if="!members.length" outlined type="warning">مشتری با مشخصات وارد شده یافت نشد.</v-alert>
										<v-row v-for="(member, index) in members" :key="index" style="border-bottom: 1px dashed #eee;">
											<v-col cols="12" sm="3">
												{{ member.fullName }}
												<div><small class="grey--text">کد ملی: {{ member.nationalCode }}</small></div>
											</v-col>
											<v-col cols="12" sm="3">
												<div>اعتبار کیف پول:</div>
												<div class="grey--text">{{ member.credit.toString().toPriceFormat() }} تومان</div>
											</v-col>
											<v-col cols="12" sm="6">
												<div class="d-flex flex-wrap justify-center">
													<v-btn small outlined color="primary" class="mx-1 mb-1" @click="newFactor(member)">ثبت صورتحساب جدید</v-btn>
													<v-btn small outlined color="info" class="mx-1" @click="memberFactors(member)">لیست صورتحساب ها</v-btn>
												</div>
											</v-col>
										</v-row>
									</div>
								</div>
							</v-slide-x-transition>

							<v-slide-x-transition :hide-on-leave="true">
								<div v-if="step === 2 || step === 3">
									<v-row class="justify-center">
										<v-col cols="12" md="7">
											<v-form ref="formFactor" @submit.prevent="submitFactor">
												<v-card>
													<div>
														<v-btn text color="grey" small @click="returnToStep1">
															<v-icon x-small class="ml-1">mdi-arrow-right</v-icon>
															بازگشت
														</v-btn>
													</div>
													<v-img class="align-end text-white" height="150" contain :src="require('@/assets/online-payment.webp')">
													</v-img>

													<v-slide-x-transition :hide-on-leave="true">
														<div v-if="step === 3" class="px-3">
															<v-alert type="success" outlined>
																صورتحساب با موفقیت ثبت شد.
																<br />
																شماره سیستمی صورتحساب: {{ localData.code }}
																<div class="text-center py-3 d-flex flex-column justify-center align-center">
																	<v-btn @click="print(localData)" color="info" outlined width="200">
																		<v-icon>mdi-printer</v-icon>
																		چاپ صورتحساب
																	</v-btn>
																	<v-btn class="mt-4" @click="step = 1" elevation="0" width="200">
																		<v-icon x-small class="ml-1">mdi-arrow-right</v-icon>
																		بازگشت</v-btn>
																</div>
															</v-alert>
														</div>
													</v-slide-x-transition>

													<div v-if="step === 2">
														<v-card-subtitle class="pt-4 text-center ">
															شما در حال ثبت صورتحساب برای شخص با مشخصات زیر می باشید:
															<v-card color="#eee" elevation="0" class="pa-2 my-2">
																<div class="secondary--text mb-2" style="font-size: 14pt;">{{ localData.member.fullName }}</div>
																<div class="grey--text">کد ملی:</div>
																<div class="secondary--text" style="font-size: 14pt;">{{ localData.member.nationalCode }}</div>
															</v-card>
														</v-card-subtitle>

														<v-card-text>
															<v-row>
																<v-col cols="12" class="pt-3 pb-8">
																	<div>
																		<div class="mb-1">
																			تاریخ صورتحساب:
																			<span class="secondary--text mr-1">{{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }}</span>
																		</div>
																		<!-- <date-picker ref="regDate2" v-model="localData.createAt" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable auto-submit :rules="[() => localData.regDate2 === '' || 'تاریخ عضویت را به صورت صحیح وارد کنید']" />
																		<div class="red--text">
																			{{ datePickerValidatioin }}
																		</div> -->
																	</div>
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-text-field outlined class="align-center center-input" :disabled="true" v-model="localData.code" :label="localData.id === emptyId ? 'شماره سیستمی (شماره پس از ذخیره ایجاد می شود)' : 'شماره سیستمی'" :error-messages="errorMessages" />
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-text-field outlined class="align-center center-input" v-model="localData.userCode" label="شماره فرعی صورتحساب (اختیاری)" :error-messages="errorMessages" />
																</v-col>
																<v-col cols="12" class="py-0">
																	<v-text-money outlined class="align-center center-input" v-model="localData.amount" label="مبلغ صورتحساب (تومان)" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید', () => localData.amount <= localData.member.credit || 'مبلغ وارد شده از اعتبار کیف پول مشتری بیشتر است']" required />
																	<v-card color="#eee" elevation="0" class="pa-2 my-2">
																		<div class="grey--text text-center d-flex flex-wrap justify-center">
																			<v-icon small color="red" v-if="localData.member.walletIsLock">mdi-lock</v-icon>
																			<span>اعتبار کیف پول:</span>
																			<span class="secondary--text mr-1" style="font-size: 16pt;">{{ localData.member.credit.toString().toPriceFormat() }}</span>
																			<span class="secondary--text mr-1" style="font-size: 11pt;">تومان</span>
																		</div>
																	</v-card>
																</v-col>
																<v-col cols="12" class="pb-0 pt-6">
																	<v-textarea outlined class="" v-model="localData.description" label="شرح اقلام صورتحساب" :error-messages="errorMessages" :rules="[() => !!localData.description || 'شرح صورتحساب را وارد کنید']" required />
																</v-col>
																<v-col cols="12" class="">
																	<v-card color="#eee" class="px-2 d-flex">
																		<v-text-field ref="mobile" :disabled="true" v-model="localData.member.mobile" maxlength="11" label="موبایل" />
																		<div class="d-flex px-2 align-center" style="width:170px">
																			<v-text-field v-model="localData.mobileOtp" maxlength="5" label="کد تایید" />
																			<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال کد</small></v-btn>
																			<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
																		</div>
																	</v-card>
																</v-col>
															</v-row>
														</v-card-text>

														<v-card-actions class="d-flex align-center justify-center mb-12">
															<v-btn v-if="!$vuetify.breakpoint.smAndDown" @click="step = 1">انصراف</v-btn>
															<v-btn v-if="!$vuetify.breakpoint.smAndDown" color="primary" type="submit" :loading="submitLoading">
																ثبت صورتحساب
															</v-btn>
															<v-btn v-if="localData && localData.id != emptyId" color="info" outlined @click="print(localData)">
																<v-icon>mdi-printer</v-icon>
																چاپ
															</v-btn>
														</v-card-actions>
													</div>
												</v-card>
												<v-bottom-navigation elevation="0" v-model="nav" active fixed color="primary" v-if="step === 2 && $vuetify.breakpoint.smAndDown" style="background-color: #f5f9ff;border-top: 1px solid #ddd;box-shadow: none;">
													<v-btn type="submit" :loading="submitLoading">
														ثبت صورتحساب
														<v-icon>mdi-cart-outline</v-icon>
													</v-btn>
												</v-bottom-navigation>
											</v-form>
										</v-col>
									</v-row>
								</div>
							</v-slide-x-transition>
						</v-tab-item>
						<v-tab-item :key="1" v-if="activeTab === 1">
							<v-row class="mt-3">
								<v-col cols="12">
									<AgentFactors ref="agentFactors" @edit="edit" @remove="remove" userType='agent' :date-range="dateRange" />
								</v-col>
							</v-row>
						</v-tab-item>
					</v-tabs-items>
				</v-tabs>
			</div>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />

		<div id="printHtml" style="display: none;">
			<agent-factor-printHtml v-if="localData && printToggler" @ready="printReady = true" :id="localData.id" />
		</div>

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import printJS from 'print-js'
	import { emptyId } from '@/util/emptyId'
	import { get } from 'vuex-pathify'
	import AgentFactors from '@/components/forms/AgentFactors.vue'

	export default {
		name: 'AgentFactorsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'agent-factor-printHtml': () => import('@/components/prints/AgentFactorPrintHtml'),
			Countdown: () => import('@/components/Countdown'),
			AgentFactors: AgentFactors
		},
		data() {
			return {
				members: null,
				sendCodeVisible: true,
				emptyId: emptyId,
				searchLoading: false,
				submitLoading: false,
				optLoading: false,
				searchMessage: '',
				step: 1,
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedMember: null,
				activeTab: 0,
				dateRange: { start: '', end: '' },
				searchPhrase: '',
				printReady: false,
				printToggler: false,
				printLoadingId: ''
			}
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			excelFileName() {
				let name = 'لیست صورتحساب های کیف پولی'
				name += '.xls'
				return name
			},
		},
		mounted() {

		},
		methods: {
			sendOTP() {
				if (!this.localData.member.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendWalletWithdrawOTP', this.localData)
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
			edit(item) {
				this.localData = item
				this.activeTab = 0
				this.step = 2
			},
			async remove(item) {
				toast.error('در حال حاضر امکان حذف صورتحساب وجود ندارد.')
				return
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/agent/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			searchCustomer() {
				this.searchMessage = ''
				if (!this.searchPhrase) {
					this.searchMessage = 'ابتدا عبارت مورد نظر جهت جستجو را وارد کنید'
					return
				}
				this.searchLoading = true
				api.get('agent/customer/GetForFactor/' + this.searchPhrase, null)
					.then(
						response => {
							this.members = response
						})
					.catch(err => {
						this.searchMessage = err.message
					})
					.finally(() => this.searchLoading = false)
			},
			async submitFactor() {
				if (!this.$refs.formFactor.validate()) {
					toast.error('لطفا ابتدا تمام موارد فرم را تکمیل نمایید.')
					return
				}
				if (!this.localData.mobileOtp) {
					toast.error('کد تائیدیه پیامکی وارد نشده است.')
					return
				}
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ثبت این صورتحساب مطمئن هستید؟',
				)) {
					this.submitLoading = true
					api.post('agent/AgentFactor/Create', this.localData)
						.then(
							response => {
								toast.success('صورتحساب با موفقیت ذخیره شد.')
								this.localData = response
								this.step = 3
								// this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.submitLoading = false
						})
				}
			},
			newFactor(member) {
				if (member.walletIsLock) {
					toast.error('متاسفانه در حال حاضر کیف پول مشتری در وضعیت قفل شده است')
					return
				}
				this.localData = {
					id: emptyId,
					member: member,
					agent: this.getCurrentUser.userData,
					createAt: new Date().toJSON()
				}
				this.step = 2
			},
			memberFactors(member) {
				this.activeTab = 1
				setTimeout(() => {
					this.$refs.agentFactors.setMember(member)
					this.$refs.agentFactors.setDateRange({ start: '', end: '' })
					this.$refs.agentFactors.loadData()
				}, 300)
			},
			returnToStep1() {
				if (this.step === 3)
					this.searchCustomer()
				this.step = 1
			},
			print(data) {
				this.printReady = false
				this.printLoadingId = data.id
				this.printToggler = false
				setTimeout(() => {
					this.localData = data
					let timer = 0
					this.printToggler = true
					let interval = setInterval(() => {
						timer++
						if (timer > 300 || this.printReady) {
							clearInterval(interval)
							this.printLoadingId = ''
						}
						if (this.printReady)
							printJS({
								printable: 'printHtml',
								type: 'html',
								scanStyles: false, // If true inline styles will be removed
								targetStyles: ['*'],
								style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtml {
												display: block !important;
												font-family: 'YekanP', sans-serif;
										}
									`
							})
						setTimeout(() => {
							this.printToggler = false
						}, 3000)
					}, 100)
				}, 100)
			},
		},
	}
</script>
<style></style>